/**
 * @param {string} timeStamp 2021-11-04T11:44:38.000Z
 * @param {string} locale en
 * @returns Returns a formatted date by locale.
 * D,M,Y: 4 November, 2021
 */

export function formatDate(timeStamp, locale) {
	const event = new Date(timeStamp);
	const options = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	};

	if (locale) {
		return event.toLocaleDateString(locale, options);
	}

	return '';
}
